import { createReducer, on } from '@ngrx/store';
import { ScatterPlotPlotType } from 'ChartApp/ts/enums/scatter-plot-common.enum';
import { setXAxisDate } from './x-axis-date.actions';
import { setScatterPlot } from 'ChartApp/ts/apps/scatter-plot/state/scatter-plot.actions';
export const xAxisDate = createReducer(null, on(setScatterPlot, (state, action) => {
    if (action.scatterPlot.plotType === ScatterPlotPlotType.pointInTime) {
        return action.scatterPlot.xAxisDate;
    }
    return state;
}), on(setXAxisDate, (state, { date }) => {
    return date;
}));
